/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="67.31" height="92.61" viewBox="0 0 67.31 92.61" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="a0aa2ef0-9a4e-4642-a9bf-fc01714d9cc7" x="-0.4" y="-0.4" width="68.11" height="93.41" maskUnits="userSpaceOnUse">
      <g transform="translate(-43.4 -30.9)">
        <polygon points="43 123.91 111.11 123.91 111.11 30.5 43 30.5 43 123.91" fill="#fff" fillRule="evenodd"/>
      </g>
    </mask>
  </defs>
  <g>
      <path d="M100.59,30.9H53.52a9.67,9.67,0,0,0-9.66,9.66V97.88a9.67,9.67,0,0,0,9.66,9.66h47.07a9.67,9.67,0,0,0,9.66-9.66V40.56A9.67,9.67,0,0,0,100.59,30.9ZM53.52,33.4h47.07a7.17,7.17,0,0,1,7.16,7.16V97.88a7.17,7.17,0,0,1-7.16,7.16H53.52a7.17,7.17,0,0,1-7.16-7.16V40.56A7.17,7.17,0,0,1,53.52,33.4Z" transform="translate(-43.4 -30.9)" fill="#0e497b"/>
      <g mask="url(#a0aa2ef0-9a4e-4642-a9bf-fc01714d9cc7)">
        <path d="M99.94,46.88H54.17a1.25,1.25,0,0,0-1.25,1.25V74.49a1.25,1.25,0,0,0,1.25,1.25H99.94a1.25,1.25,0,0,0,1.25-1.25V48.13A1.25,1.25,0,0,0,99.94,46.88Zm-1.25,2.5V73.24H55.42V49.38Z" transform="translate(-43.4 -30.9)" fill="#0e497b"/>
      </g>
      <g mask="url(#a0aa2ef0-9a4e-4642-a9bf-fc01714d9cc7)">
        <path d="M67.69,39H86.41a1.25,1.25,0,0,1,.13,2.5H67.69A1.25,1.25,0,0,1,67.56,39Z" transform="translate(-43.4 -30.9)" fill="#fcb61c"/>
      </g>
      <g mask="url(#a0aa2ef0-9a4e-4642-a9bf-fc01714d9cc7)">
        <path d="M59.79,81.55a6.92,6.92,0,1,0,6.91,6.91A6.92,6.92,0,0,0,59.79,81.55Zm0,2.5a4.42,4.42,0,1,1-4.41,4.41A4.42,4.42,0,0,1,59.79,84.05Z" transform="translate(-43.4 -30.9)" fill="#fcb61c"/>
      </g>
      <g mask="url(#a0aa2ef0-9a4e-4642-a9bf-fc01714d9cc7)">
        <path d="M94.26,81.55a6.92,6.92,0,1,0,6.93,6.91A6.92,6.92,0,0,0,94.26,81.55Zm0,2.5a4.42,4.42,0,1,1-4.41,4.41A4.43,4.43,0,0,1,94.26,84.05Z" transform="translate(-43.4 -30.9)" fill="#fcb61c"/>
      </g>
      <g mask="url(#a0aa2ef0-9a4e-4642-a9bf-fc01714d9cc7)">
        <path d="M61.3,105.59a1.25,1.25,0,0,1,1.77,1.76l-.1.1L45.49,123.19a1.25,1.25,0,0,1-1.77-1.76l.09-.1Z" transform="translate(-43.4 -30.9)" fill="#0e497b"/>
      </g>
      <g mask="url(#a0aa2ef0-9a4e-4642-a9bf-fc01714d9cc7)">
        <path d="M91.26,105.8a1.25,1.25,0,0,1,1.65-.17l.11.09,17.27,15.61a1.25,1.25,0,0,1-1.57,1.94l-.1-.08L91.34,107.57A1.25,1.25,0,0,1,91.26,105.8Z" transform="translate(-43.4 -30.9)" fill="#0e497b"/>
      </g>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'SubwayTrainOnTracksIcon';

export default Icon;
